import type {
  RouteLocation,
  RouteLocationNormalized,
  RouteRecordRaw,
} from "vue-router";
import type { AbilitiesEvaluation } from "vue-simple-acl/types/acl";
import { ACLRoles } from "~/core/models/ACLRoles.enum";
import { canWithRedirection } from "~/core/utils/canWithRedirection";
import {
  PATH_ORGANIZATIONS_ID,
  PATH_ORGANIZATIONS_ID_SETTINGS,
  PATH_ORGANIZATIONS_ID_SETTINGS_INFORMATION,
  PATH_ORGANIZATIONS_ID_SETTINGS_LICENSE,
  PATH_ORGANIZATIONS_ID_SETTINGS_LOGS,
  PATH_ORGANIZATIONS_ID_SETTINGS_RELATIONS,
  PATH_ORGANIZATIONS_ID_SETTINGS_RELATIONS_AFFILIATIONS,
  PATH_ORGANIZATIONS_ID_SETTINGS_RELATIONS_DELEGATIONS,
  PATH_ORGANIZATIONS_ID_SETTINGS_USERS,
  PATH_ORGANIZATIONS_ID_SETTINGS_USERS_LOGIN,
  PATH_ORGANIZATIONS_ID_SETTINGS_USERS_LOGIN_DELEGATION,
  PATH_ORGANIZATIONS_ID_SETTINGS_USERS_LOGIN_INFORMATION,
} from "~/modules/organization/constants";
import OrganizationSettingsPage from "~/modules/organization/views/OrganizationSettingsPage.vue";
import { router } from "~/plugins/router";

const routes: RouteRecordRaw[] = [
  {
    path: PATH_ORGANIZATIONS_ID,
    redirect: (to: RouteLocation) =>
      router.resolve({
        name: PATH_ORGANIZATIONS_ID_SETTINGS,
        params: { id: to.params.id },
      }),
  },
  {
    path: PATH_ORGANIZATIONS_ID_SETTINGS,
    redirect: (to: RouteLocation) =>
      router.resolve({
        name: PATH_ORGANIZATIONS_ID_SETTINGS_INFORMATION,
        params: { id: to.params.id },
      }),
  },
  {
    path: PATH_ORGANIZATIONS_ID_SETTINGS_INFORMATION,
    component: OrganizationSettingsPage,
    meta: {
      layout: "AdministrationLayout",
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: AbilitiesEvaluation,
      ) => canWithRedirection(can, ACLRoles.CAN_READ_ORG),
    },
  },
  // Note: Do not use redirect here because the tab "Affiliation" can be not displayed.
  //       It will be replaced in the component RelationsComponent.
  {
    path: PATH_ORGANIZATIONS_ID_SETTINGS_RELATIONS,
    component: OrganizationSettingsPage,
    meta: {
      layout: "AdministrationLayout",
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: AbilitiesEvaluation,
      ) => canWithRedirection(can, ACLRoles.CAN_READ_RELATION),
    },
  },
  {
    path: PATH_ORGANIZATIONS_ID_SETTINGS_RELATIONS_AFFILIATIONS,
    component: OrganizationSettingsPage,
    meta: {
      layout: "AdministrationLayout",
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: AbilitiesEvaluation,
      ) => canWithRedirection(can, ACLRoles.CAN_READ_RELATION),
    },
  },
  {
    path: PATH_ORGANIZATIONS_ID_SETTINGS_RELATIONS_DELEGATIONS,
    component: OrganizationSettingsPage,
    meta: {
      layout: "AdministrationLayout",
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: AbilitiesEvaluation,
      ) => canWithRedirection(can, ACLRoles.CAN_READ_RELATION),
    },
  },
  {
    path: PATH_ORGANIZATIONS_ID_SETTINGS_USERS,
    component: OrganizationSettingsPage,
    meta: {
      layout: "AdministrationLayout",
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: AbilitiesEvaluation,
      ) => canWithRedirection(can, ACLRoles.CAN_READ_USER),
    },
  },
  {
    path: PATH_ORGANIZATIONS_ID_SETTINGS_LOGS,
    component: OrganizationSettingsPage,
    meta: {
      layout: "AdministrationLayout",
    },
  },
  {
    path: PATH_ORGANIZATIONS_ID_SETTINGS_LICENSE,
    component: OrganizationSettingsPage,
    meta: {
      layout: "AdministrationLayout",
    },
  },
  {
    path: PATH_ORGANIZATIONS_ID_SETTINGS_USERS_LOGIN,
    redirect: (to: RouteLocation) =>
      router.resolve({
        name: PATH_ORGANIZATIONS_ID_SETTINGS_USERS_LOGIN_INFORMATION,
        params: { id: to.params.id, userLogin: to.params.userLogin },
      }),
  },
  {
    path: PATH_ORGANIZATIONS_ID_SETTINGS_USERS_LOGIN_INFORMATION,
    component: OrganizationSettingsPage,
    meta: {
      layout: "AdministrationLayout",
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: AbilitiesEvaluation,
      ) => canWithRedirection(can, ACLRoles.CAN_WRITE_USER),
    },
  },
  {
    path: PATH_ORGANIZATIONS_ID_SETTINGS_USERS_LOGIN_DELEGATION,
    component: OrganizationSettingsPage,
    meta: {
      layout: "AdministrationLayout",
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: AbilitiesEvaluation,
      ) => canWithRedirection(can, ACLRoles.CAN_WRITE_USER),
    },
  },
];

export default routes;
